import axios from 'axios';
import { getStorage, message, reqLoading, clearLoading, clearStorage,Toast } from './common';
import router from '@/router';
import { getLanguage } from '@/lang';
import verConfig from './config';
import { useUserStore } from '@/store';
const Base_Url = verConfig.Base_Url;
const Base_api = verConfig.Base_api
const api = axios.create({
  baseURL: Base_Url + Base_api
})

let requestCount = 0;

api.interceptors.request.use(function (config) {
  const { data = {}, params = {}, ...newConfig } = config;
  let targets = null;
  let obj = {}
  if (config.method == 'post') {
    const { target, ...newData } = data;
    targets = target;
    obj = { data: newData, params }
  } else {
    const { target, ...newParams } = params;
    targets = target;
    obj = { params: newParams, data }
  }
  if (requestCount === 0) {
    reqLoading(targets ? { 'target': targets } : {});
  }
  requestCount++;
  config.headers = {
    ...config.headers,
  }
  return { ...newConfig, ...obj };
}, function (error) {
  requestCount--;
  if (requestCount === 0) {
    clearLoading();
  }
  return Promise.reject(error);
});

api.interceptors.response.use(function (response) {
  const { config: { url } } = response;
  const { ret, data, msg } = response.data;
  requestCount--;
  if (requestCount === 0) {
    clearLoading();
  }
  if (ret == -1) {
    clearStorage('token');
    const userStore = useUserStore();
    userStore.setUserInfo({})
    clearStorage('userInfo')
    if (url != '/coin/user/amount') {
      message({ content: msg }, 'error')
      router.push('/');
    }
    return Promise.reject({ ret, data, msg })
  }
  if (ret == 0) {
    return Promise.reject({ ret, data, msg })
  }
  return Promise.resolve(response.data)
}, function (error) {
  requestCount--;
  if (requestCount === 0) {
    clearLoading();
    if(error.message){
      return Toast(error.message,'error');
    }
  }
  return Promise.reject(error);
});

export const get = (url, params, headers = {}) => api.get(url, {
  params, headers: {
    ...headers,
    token: getStorage('token'),
    lang: getLanguage()
  }
});
export const post = (url, data, headers = {}) => api.post(url, data, {
  headers: {
    ...headers,
    token: getStorage('token'),
    lang: getLanguage()
  }
});

export const upload = (formData, headers = {}) => {
  return post('/users/upload', formData, headers);
};